export enum WizardStepName {
  ShowPlanDetails = 0,
  ShowFinalSummary = 1,
  LoginComponent = 2
}
